/* ==========================================================================
   CAIXA FILOSOFAL - Gaveta de orcamento

   Este site nao vende. O carrinho nativo da Shopify e usado como LISTA DE
   ORCAMENTO: sem preco, sem checkout, terminando no WhatsApp.

   O desenho (prototipo/orcamento.html) resolve o buraco que sobra quando se
   tira o preco de um carrinho:
     onde moraria o preco da linha -> a personalizacao escolhida
     onde moraria o subtotal       -> o total de unidades contra o minimo

   Linguagem (docs/03-copy.md): nunca "comprar", "sacola" ou "checkout".
   E "seu pedido" e "pedir orcamento".
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.CF_PEDIDO || {};
  var LIMITE_URL = 1900; // wa.me quebra perto de 2000. Margem de seguranca.

  /* Cores do design system, para o pontinho ao lado da opcao escolhida.
     Chave sem acento e em minuscula: a comparacao normaliza antes. */
  var CORES = {
    'preto': '#1E1E1E',
    'azul': '#0533FD',
    'azul claro': '#E3EBFC',
    'verde': '#06E59C',
    'verde agua': '#06E59C',
    'branco': '#FFFFFF'
  };

  var el = {};
  var carrinhoAtual = null;

  /* ---------- utilidades ---------- */

  function $(sel, raiz) {
    return (raiz || document).querySelector(sel);
  }

  function texto(s) {
    return String(s == null ? '' : s);
  }

  function escapar(s) {
    var d = document.createElement('div');
    d.textContent = texto(s);
    return d.innerHTML;
  }

  function semAcento(s) {
    return texto(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  /* ---------- avisos para quem estiver ouvindo ----------

     pedido.js NAO conhece o Google Tag Manager, e nao deve conhecer. Ele
     apenas anuncia o que aconteceu; quem traduz isso para dataLayer e
     medicao.js, que pode ser apagado sem que uma linha daqui mude.

     O fluxo carrinho -> WhatsApp e a coisa mais cara do projeto. Ele nao pode
     passar a depender de codigo de marketing, entao cada emissao vai em
     try/catch: um ouvinte que lance excecao nao pode derrubar o envio. */

  function emitir(nome, dados) {
    try {
      document.dispatchEvent(new CustomEvent(nome, { detail: dados || {} }));
    } catch (e) {}
  }

  /* A Shopify usa "_" no inicio da chave para propriedades ocultas. */
  function propriedadesVisiveis(item) {
    var props = item.properties || {};
    var lista = [];
    for (var chave in props) {
      if (!Object.prototype.hasOwnProperty.call(props, chave)) continue;
      if (chave.charAt(0) === '_') continue;
      var valor = props[chave];
      if (valor == null || texto(valor).trim() === '') continue;
      lista.push({ chave: chave, valor: texto(valor) });
    }
    return lista;
  }

  /* ---------- quem está pedindo (passo 2, desenho C de 31/08) ----------

     Os campos vivem na GAVETA, e não no formulário do produto: nome e empresa
     são da pessoa, não do item. Em properties[] eles se repetiriam em cada
     linha do carrinho, e a Juliana leria o mesmo nome três vezes.

     Nenhum deles é obrigatório. Vazio, sai o rótulo com dois pontos e nada
     depois — exatamente o que a mensagem fazia antes de existirem, e é o que
     faz a Juliana perguntar na conversa.

     O localStorage é conveniência de quem volta, então toda leitura e toda
     escrita vão em try/catch: em aba anônima, ou com dados de site bloqueados,
     o próprio acesso pode lançar. Falhar aqui não pode derrubar o envio. */

  var CHAVE_QUEM = 'cf-quem';

  function camposQuem() {
    return document.querySelectorAll('[data-cf-quem]');
  }

  /* <input type="date"> devolve 2026-11-10. A Juliana lê data em português.

     E desde 11/09 um dos campos é `textarea`: a mensagem do WhatsApp é uma
     linha por campo, então uma resposta de três linhas quebraria o formato e
     as linhas soltas apareceriam sem rótulo, como se fossem outro item do
     pedido. As quebras viram " · ", que é o mesmo separador que a mensagem
     já usa dentro de uma linha. */
  function valorQuem(campo) {
    var v = texto(campo.value).trim().replace(/\s*\n+\s*/g, ' \u00b7 ');
    var iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    return iso ? iso[3] + '/' + iso[2] + '/' + iso[1] : v;
  }

  function linhasQuem() {
    var campos = camposQuem();
    if (!campos.length) return null;
    return Array.prototype.map.call(campos, function (c) {
      return c.getAttribute('data-cf-quem') + ': ' + valorQuem(c);
    });
  }

  function guardarQuem() {
    var dados = {};
    Array.prototype.forEach.call(camposQuem(), function (c) {
      dados[c.getAttribute('data-cf-quem')] = c.value;
    });
    try { window.localStorage.setItem(CHAVE_QUEM, JSON.stringify(dados)); } catch (e) {}
  }

  function lembrarQuem() {
    var dados;
    try { dados = JSON.parse(window.localStorage.getItem(CHAVE_QUEM) || '{}'); } catch (e) { dados = null; }
    if (dados && typeof dados === 'object') {
      Array.prototype.forEach.call(camposQuem(), function (c) {
        var v = dados[c.getAttribute('data-cf-quem')];
        if (v) c.value = v;
      });
    }
    resumirQuem();
  }

  /* ---------- o resumo na dobra fechada (08/09, opcao C2) ----------

     O passo 2 era 290px sempre abertos. Fechado, ele devolve mais espaco que
     todos os outros blocos somados — e cria um problema novo: quem preencheu
     ontem abre a gaveta hoje, ve uma dobra fechada e nao tem como saber que
     os dados continuam guardados no localStorage. Preencheria de novo, ou
     pior, concluiria que o site perdeu.

     Entao a dobra fechada passa a MOSTRAR o que ja tem, e fica verde. E a
     mesma informacao que o botao vai mandar, no lugar onde a pessoa procura
     antes de decidir se abre.

     Data e CEP ficam de fora do resumo de proposito: nome e empresa
     identificam, e sao o que a Juliana precisa ler primeiro. Os quatro
     continuam indo inteiros na mensagem. */
  function resumirQuem() {
    var alvo = el.drawer && $('[data-cf-quem-resumo]', el.drawer);
    var dobra = el.drawer && $('[data-cf-passo2]', el.drawer);
    if (!alvo) return;

    var identidade = ['Nome', 'Empresa'];
    var cheios = [];

    Array.prototype.forEach.call(camposQuem(), function (c) {
      var rot = c.getAttribute('data-cf-quem');
      var v = texto(c.value).trim();
      if (v && identidade.indexOf(rot) >= 0) cheios.push(v);
    });

    /* Data e CEP nao entram no resumo, mas contam para o estado: quem so
       preencheu o prazo tambem preencheu alguma coisa. */
    var algum = cheios.length > 0;
    if (!algum) {
      Array.prototype.forEach.call(camposQuem(), function (c) {
        if (texto(c.value).trim()) algum = true;
      });
    }

    if (dobra) dobra.classList.toggle('esta-preenchido', algum);

    if (cheios.length) {
      alvo.textContent = cheios.join(' · ');
    } else if (algum) {
      alvo.textContent = 'Preenchido. Toque para conferir.';
    } else {
      alvo.textContent = 'Opcional. Em branco, ela pergunta na conversa.';
    }
  }

  /* ---------- estado ---------- */

  function atualizar() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js respondeu ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        carrinhoAtual = cart;
        renderizar(cart);
        return cart;
      })
      .catch(function (erro) {
        console.error('[CF] falha ao ler o pedido:', erro);
      });
  }

  /* ---------- render ---------- */

  function renderizar(cart) {
    var vazio = cart.items.length === 0;

    if (el.vazio) el.vazio.hidden = !vazio;
    if (el.rodape) el.rodape.hidden = vazio;
    if (el.notaVazia) el.notaVazia.hidden = !vazio;
    if (el.medidor) el.medidor.hidden = vazio;
    /* A fita sai junto com a barra: benefício para quem ainda não escolheu
       nada é resposta antes da pergunta, e o estado vazio já é um cardápio
       dos 3 produtos. */
    if (el.fita) el.fita.hidden = vazio;

    if (el.conta) {
      el.conta.hidden = vazio;
      el.conta.textContent = cart.items.length + (cart.items.length === 1 ? ' produto' : ' produtos');
    }

    document.querySelectorAll('[data-cf-contador]').forEach(function (n) {
      /* Linhas, nao unidades. cart.item_count e a SOMA das quantidades: com
         um pedido de 30 unidades a cracha ao lado de "Orcamento" mostrava 30
         enquanto a gaveta, logo abaixo, dizia "1 produto". Dois numeros
         discordando no mesmo painel. */
      n.textContent = cart.items.length;
      n.hidden = cart.items.length === 0;
    });

    if (el.itens) {
      el.itens.innerHTML = vazio ? '' : cart.items.map(linhaItem).join('');
    }

    atualizarMedidor(cart);
    atualizarPrevia(cart);
  }

  /* ---------- uma pill por adicional (09/09, pedido do Elber) ----------

     O valor que vem do carrinho JA E UMA LISTA. Os kits gravam
     "Porta-retrato + bag personalizada + tag" numa property so, e numa pill
     unica isso vira um rotulo de 40 caracteres que quebra no MEIO da frase:
     "bag" numa linha, "personalizada" na outra. Foi o que o Elber viu.

     Cortando no " + ", cada adicional vira uma pill curta e a quebra passa a
     acontecer ENTRE pills, que e onde ela nao incomoda. E o corte nao e
     truque de layout: o que a pessoa escolheu foi um conjunto de itens, nao
     uma frase, e tres etiquetas dizem isso melhor que uma.

     O PRIMEIRO PEDACO SAI quando ele so repete o nome do produto, que esta
     no <h3> a um centimetro dali. "Porta-Retrato Filosofal" com uma pill
     escrito "Porta-retrato" embaixo nao informa nada, e era ele que ocupava
     94px dos 128 que a faixa tem. Sai por medida e por sentido.

     Sai so quando ha o que sobrar: "Porta-retrato" sozinho, que e o kit sem
     bag e sem tag, CONTINUA aparecendo. Ali a pill nao repete o nome, ela
     diz que a pessoa nao escolheu adicional nenhum, e vazio nao diz isso.

     A comparacao e por prefixo e sem acento, entao "Calendario" casa com
     "Calendario Filosofal" e "Quadro" com "Quadro Filosofal" sem lista de
     nomes escrita no codigo.

     A mensagem do WhatsApp NAO muda. `montarMensagem` usa `p.valor` cru, e a
     Juliana continua lendo "Porta-retrato + bag personalizada + tag" numa
     linha so, que e o nome do kit no orcamento dela.

     A maiuscula entra so nas partes que sobem de posicao depois do corte. Um
     valor sem " + " passa intacto, entao o que a Juliana escrever no editor
     chega na pill exatamente como ela escreveu.

     A cor tambem passou a ser procurada por PARTE, e nao pelo valor inteiro.
     Para os valores de hoje da no mesmo (a cor vem sozinha na sua property),
     mas se um dia ela compuser "Moldura natural + Azul", a bolinha aparece
     na parte certa em vez de sumir.

     O "+" ENTRE AS PILLS (09/09, segunda volta do Elber). Ele pediu a
     estrutura "pill + pill + pill", com o sinal, e nao pills soltas com um
     vao entre elas.

     O sinal so entra DENTRO de uma property, que e onde ele diz a verdade:
     bag e tag sao pedacos de um kit, somados. Entre uma property e outra ele
     nao entra, porque "Tag + Azul" leria a cor como mais um item do kit, e
     cor nao e item — e a mesma separacao que a mensagem do WhatsApp ja faz,
     com " + " dentro do valor e " · " entre valores.

     `aria-hidden` no sinal: ele e pontuacao visual. Um leitor de tela lendo
     "Bag personalizada mais Tag" transforma duas etiquetas numa conta. */
  function pillsDaPropriedade(valor, nomeProduto) {
    var partes = valor.split(' + ');

    if (partes.length > 1 && semAcento(nomeProduto).indexOf(semAcento(partes[0].trim())) === 0) {
      partes = partes.slice(1);
    }

    return partes.map(function (parte, i) {
      var t = parte.trim();
      if (!t) return '';
      /* Maiuscula em tudo que nao veio na primeira posicao do valor original:
         "bag personalizada" era continuacao de frase e agora e etiqueta. */
      if (i > 0 || partes.length < valor.split(' + ').length) {
        t = t.charAt(0).toUpperCase() + t.slice(1);
      }

      var cor = CORES[semAcento(t)];
      var ponto = cor
        ? '<span class="marca-opcao__ponto" style="background:' + cor +
          (semAcento(t) === 'branco' ? ';border:1px solid var(--borda)' : '') + '"></span> '
        : '';
      return '<span class="marca-opcao">' + ponto + escapar(t) + '</span>';
    }).filter(Boolean).join('<span class="marca-opcao__mais" aria-hidden="true">+</span>');
  }

  function linhaItem(item) {
    var opcoes = propriedadesVisiveis(item).map(function (p) {
      return pillsDaPropriedade(p.valor, item.product_title);
    }).join('');

    var foto = item.image
      ? '<img src="' + escapar(item.image) + '" alt="" width="52" height="52" loading="lazy">'
      : '';

    var nome = escapar(item.product_title);

    /* ---------- DUAS LINHAS, E NAO TRES (08/09, opcao B2) ----------

       A linha media 162px: foto de 68px ao lado de nome, marcas e controles
       empilhados, com 48px so de respiro vertical. Numa gaveta cuja moldura
       fixa ja comia 722px de 945, cabia 1,4 item.

       Agora sao duas linhas. Em cima o nome e a lixeira; embaixo as marcas e
       o contador dividem a mesma faixa. 84px, e o mesmo conteudo.

       O "Tirar" sublinhado virou icone por dois motivos. Ele tinha peso de
       link num lugar onde o unico link deveria ser o botao de enviar, e
       morava COLADO no "menos" do contador: dois alvos vizinhos, um que tira
       uma unidade e outro que apaga o item inteiro.

       09/09: ele voltou para a faixa do contador, e a razao de 08/09 continua
       respeitada. O que criava o risco era a VIZINHANCA, nao a faixa: agora o
       contador esta ancorado a esquerda e a lixeira na ponta direita, com a
       largura do item inteira entre os dois.

       O que ele estava custando la em cima: a lixeira tem 40px de alvo de
       toque e o titulo tem 17,6 de altura, entao a faixa do nome media 40 e
       sobravam 22,4px de vao morto embaixo do titulo, em todo item da lista.
       Era o "espacamento vago e sem sentido" que o Elber apontou. Aqui
       embaixo ela cabe na altura que o contador ja paga, e o item encolhe
       sem perder nada.

       O aria-label carrega o nome do produto porque numa lista de tres itens
       "Tirar" repetido tres vezes nao diz ao leitor de tela o que sai. */
    var lixeira =
      '<button type="button" class="item-orc__tirar" data-cf-remover ' +
        'aria-label="Tirar ' + nome + ' do pedido">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
          'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path class="item-orc__tampa" d="M3 6h18M9 6V4h6v2"></path>' +
          '<path d="M6 6l1 14h10l1-14"></path>' +
        '</svg>' +
      '</button>';

    return '' +
      '<article class="item-orc" data-chave="' + escapar(item.key) + '">' +
        '<div class="item-orc__foto">' + foto + '</div>' +
        '<div class="item-orc__col">' +
          '<div class="item-orc__cab">' +
            '<h3 class="item-orc__nome">' + nome + '</h3>' +
          '</div>' +
          '<div class="item-orc__pe">' +
            '<div class="item-orc__opcoes">' + opcoes + '</div>' +
            '<div class="contador">' +
              '<button type="button" data-cf-menos aria-label="Diminuir quantidade de ' + nome + '">&minus;</button>' +
              '<input type="number" value="' + item.quantity + '" min="1" step="1" inputmode="numeric" data-cf-qtd ' +
                'aria-label="Quantidade de ' + nome + '">' +
              '<button type="button" data-cf-mais aria-label="Aumentar quantidade de ' + nome + '">+</button>' +
            '</div>' +
            lixeira +
          '</div>' +
        '</div>' +
      '</article>';
  }

  /* Onde moraria o subtotal. Avisa quando esta abaixo do minimo, mas NAO trava
     o botao: travar botao em site B2B faz o comprador desistir em silencio, e
     20 unidades ainda e um lead que a Juliana quer atender. */
  function atualizarMedidor(cart) {
    if (!el.medidor) return;
    var minimo = parseInt(cfg.pedidoMinimo, 10) || 0;
    var total = cart.item_count;
    var ok = minimo === 0 || total >= minimo;

    el.medidor.setAttribute('data-ok', ok ? 'true' : 'false');
    if (el.medidorNum) el.medidorNum.textContent = total;

    if (el.medidorBarra) {
      var pct = minimo ? Math.min(100, Math.round((total / minimo) * 100)) : 100;
      el.medidorBarra.style.width = pct + '%';
    }

    if (el.medidorAviso) {
      if (ok) {
        el.medidorAviso.textContent = 'Acima do mínimo. Pode pedir.';
      } else {
        var faltam = minimo - total;
        el.medidorAviso.textContent =
          (faltam === 1 ? 'Falta ' : 'Faltam ') + faltam + (faltam === 1 ? ' unidade' : ' unidades') +
          ' para o pedido mínimo de ' + minimo + '.';
      }
    }
  }

  /* ---------- mensagem do WhatsApp ---------- */

  /* Formato vindo do desenho (prototipo/carrinho.html). Duas escolhas dele que
     valem registrar:

     1. As opcoes vao numa linha so, separadas por ponto medio, em vez de uma
        linha por propriedade. A mensagem cabe na tela do celular da Juliana
        sem rolar, e ela le o pedido inteiro de uma vez.
     2. A mensagem termina com os dados de quem esta pedindo. Ate 31/08 eram
        rotulos EM BRANCO para a Juliana completar na conversa; desde entao
        sao os campos do passo 2 da gaveta, e o que fica em branco continua
        saindo como rotulo vazio — o comportamento antigo virou o piso, nao
        o padrao. */
  function montarMensagem(cart) {
    var quebra = String.fromCharCode(10);
    var linhas = [texto(cfg.saudacao), ''];

    cart.items.forEach(function (item, i) {
      linhas.push(i + 1 + '. ' + item.product_title);

      var props = propriedadesVisiveis(item);
      if (props.length) {
        linhas.push('   ' + props.map(function (p) { return p.valor; }).join(' · '));
      }

      linhas.push('   ' + item.quantity + (item.quantity === 1 ? ' unidade' : ' unidades'));
      linhas.push('');
    });

    linhas.push('Total: ' + cart.item_count + ' unidades');
    linhas.push('');

    /* Havendo os campos do passo 2, são eles. Sem eles — se alguém tirar o
       bloco da gaveta — volta a lista de rótulos em branco das settings, que
       era o comportamento até 31/08. */
    var quem = linhasQuem();
    if (quem) {
      linhas = linhas.concat(quem);
    } else {
      texto(cfg.campos).split(quebra).forEach(function (c) {
        if (c.trim()) linhas.push(c.trim());
      });
    }

    return linhas.join(quebra);
  }

  /* A previa mostra a mensagem exata que vai sair. Derruba a hesitacao de
     clicar num botao de WhatsApp sem saber o que vem depois. */
  function atualizarPrevia(cart) {
    /* Escopado a bolha da mensagem de proposito. Um seletor solto por atributo
       pegava a previa de cor da pagina de produto e a apagava com textContent.
       Se um terceiro elemento reusar o nome, este aqui nao o alcanca. */
    var alvo = document.querySelector('.mensagem__bolha[data-cf-previa]');
    if (!alvo) return;
    alvo.textContent = cart.items.length ? montarMensagem(cart) : '';
  }

  function limitar(mensagem) {
    if (encodeURIComponent(mensagem).length <= LIMITE_URL) return mensagem;
    var corte = mensagem;
    var rodape = '\n\n(pedido resumido, o restante eu falo por aqui)';
    while (corte.length > 0 && encodeURIComponent(corte + rodape).length > LIMITE_URL) {
      corte = corte.slice(0, -80);
    }
    return corte + rodape;
  }

  function enviarWhatsApp() {
    if (!carrinhoAtual || !carrinhoAtual.items.length) return;
    var mensagem = montarMensagem(carrinhoAtual);

    /* Antes do window.open, de proposito. Depois dele o navegador ja pode
       ter tirado o foco da aba, e no celular a troca para o WhatsApp e
       imediata — o que ficasse para depois corria o risco de nao ir. Esta e
       a conversao principal do site: ela nao pode ser a que se perde. */
    emitir('cf:pedido:enviado', { cart: carrinhoAtual, mensagem: mensagem });

    var url = 'https://wa.me/' + cfg.numero + '?text=' + encodeURIComponent(limitar(mensagem));
    /* Sem 'noopener' na string de features, de proposito. Pela especificacao,
       window.open com noopener retorna null MESMO QUANDO A JANELA ABRE — e a
       deteccao abaixo passava a ser verdadeira em 100% dos envios. Resultado:
       a pessoa mandava o pedido, o WhatsApp abria, e ao voltar encontrava um
       aviso dizendo que nao tinha aberto. Depois de um envio certo, isso e o
       pior sinal possivel, e gera pedido duplicado.

       A protecao contra o opener continua, feita na mao logo abaixo. */
    var janela = window.open(url, '_blank');
    if (janela) janela.opener = null;

    if (!janela || janela.closed || typeof janela.closed === 'undefined') {
      var seguir = function () {
        if (el.fallback) el.fallback.hidden = false;
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(mensagem).then(seguir, seguir);
      } else {
        seguir();
      }
    }
  }

  /* ---------- abrir e fechar ---------- */

  var ultimoFoco = null;

  /* ---------- a fita de benefício (08/09, opção A3) ----------

     Ela ocupa a faixa onde morava o medidor de 125px. Gira porque um
     benefício só ficaria parado na tela a viagem inteira e viraria moldura:
     o olho para de ver o que nunca muda. Cinco segundos é o tempo de ler uma
     linha curta sem sentir pressa.

     Só gira com a gaveta ABERTA. Um intervalo rodando atrás de uma gaveta
     fechada é trabalho de CPU cobrado de todo mundo que nunca abriu o
     carrinho, e este site já briga por milissegundos de thread principal.

     Com `prefers-reduced-motion` a troca continua acontecendo (a informação
     é a mesma para todo mundo), mas sem a transição: quem pediu menos
     movimento pediu menos animação, não menos conteúdo. */
  var relogioFita = null;
  var fitaIndice = 0;
  var fitaLista = [];

  function lerFita() {
    var fonte = el.fita && $('[data-cf-fita-lista]', el.fita);
    if (!fonte) return [];
    try {
      var lista = JSON.parse(fonte.textContent);
      return Array.isArray(lista) ? lista.map(function (t) { return texto(t).trim(); }).filter(Boolean) : [];
    } catch (e) { return []; }
  }

  function girarFita() {
    if (!el.fita || fitaLista.length < 2) return;
    var alvo = $('[data-cf-fita-texto]', el.fita);
    var pontos = el.fita.querySelectorAll('.fita__pontos i');
    if (!alvo) return;

    fitaIndice = (fitaIndice + 1) % fitaLista.length;

    el.fita.classList.add('esta-trocando');
    window.setTimeout(function () {
      alvo.textContent = fitaLista[fitaIndice];
      Array.prototype.forEach.call(pontos, function (p, i) {
        p.classList.toggle('esta-ativo', i === fitaIndice);
      });
      el.fita.classList.remove('esta-trocando');
    }, 180);
  }

  function tocarFita(ligar) {
    window.clearInterval(relogioFita);
    relogioFita = null;
    if (!ligar || !el.fita || fitaLista.length < 2) return;
    relogioFita = window.setInterval(girarFita, 5000);
  }

  function abrir(origem) {
    if (!el.drawer) return;
    window.clearTimeout(relogioFechar);
    tocarFita(true);
    ultimoFoco = document.activeElement;
    el.drawer.hidden = false;
    requestAnimationFrame(function () {
      el.drawer.classList.add('esta-aberto');
      document.documentElement.classList.add('pedido-travado');
      /* O primeiro [data-cf-fechar] da gaveta e o VEU, uma div sem tabindex:
         .focus() nela nao faz nada, o foco continuava no botao que abriu — que
         esta fora do dialogo — e o primeiro Tab escapava para o rodape. */
      var alvo = $('.gaveta__fechar', el.drawer) || $('[data-cf-painel] [data-cf-fechar]', el.drawer);
      if (alvo && alvo.focus) alvo.focus();
    });
    /* Depois de atualizar, e nao antes: o aviso leva o conteudo do pedido
       junto, e antes do fetch o carrinho pode estar vazio ou velho. */
    atualizar().then(function (cart) {
      if (cart) emitir('cf:pedido:aberto', { cart: cart, origem: origem || 'botao' });
    });
  }

  /* O relogio do fechamento precisa ser cancelavel. Sem isso, fechar e reabrir
     dentro dos 240ms da animacao deixava a gaveta com hidden=true e o <html>
     com pedido-travado: a gaveta sumia, a pagina ficava sem rolagem e nao
     sobrava nada visivel para fechar. So recarregando.

     No celular isso e um duplo toque acidental, com a barra fixa a um polegar
     de distancia do botao. */
  var relogioFechar = null;

  function fechar() {
    if (!el.drawer) return;
    tocarFita(false);
    el.drawer.classList.remove('esta-aberto');
    document.documentElement.classList.remove('pedido-travado');
    if (el.fallback) el.fallback.hidden = true;
    window.clearTimeout(relogioFechar);
    relogioFechar = window.setTimeout(function () {
      el.drawer.hidden = true;
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }, 240);
  }

  function prenderFoco(evento) {
    if (evento.key !== 'Tab' || el.drawer.hidden) return;
    var focaveis = el.drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var visiveis = Array.prototype.filter.call(focaveis, function (n) {
      return n.offsetParent !== null;
    });
    if (!visiveis.length) return;
    var primeiro = visiveis[0];
    var ultimo = visiveis[visiveis.length - 1];
    if (evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  }

  /* ---------- alteracoes ---------- */

  function mudarQuantidade(chave, quantidade) {
    /* O item precisa ser lido ANTES da troca: depois dela, se a quantidade
       foi para zero, ele nao existe mais no carrinho e nao ha o que anunciar. */
    var antes = null;
    if (carrinhoAtual && carrinhoAtual.items) {
      carrinhoAtual.items.forEach(function (i) { if (i.key === chave) antes = i; });
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: chave, quantity: quantidade })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change.js respondeu ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        carrinhoAtual = cart;
        renderizar(cart);
        if (antes) {
          emitir('cf:pedido:alterado', {
            item: antes,
            de: antes.quantity,
            para: quantidade,
            cart: cart
          });
        }
      })
      .catch(function (erro) {
        console.error('[CF] falha ao mudar quantidade:', erro);
      });
  }

  function adicionar(formulario) {
    var botao = $('[type="submit"]', formulario);
    if (botao) botao.disabled = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(formulario)
    })
      .then(function (r) {
        return r.json().then(function (corpo) {
          if (!r.ok) throw new Error(corpo.description || corpo.message || 'erro ao adicionar');
          return corpo;
        });
      })
      .then(function (item) {
        /* A resposta de /cart/add.js E o item de carrinho ja montado, com
           quantidade, variante e as properties da personalizacao. Era
           descartada aqui; agora ela e o conteudo do aviso. */
        emitir('cf:pedido:adicionado', { item: item, formulario: formulario });
        /* A gaveta abrir sozinha e o unico retorno de que funcionou. Num site
           sem preco e sem total, nao ha outro sinal. */
        abrir('adicao');
      })
      .catch(function (erro) {
        console.error('[CF] falha ao adicionar ao pedido:', erro);
        window.alert('Não consegui adicionar ao seu pedido. Tente de novo em instantes.');
      })
      .then(function () {
        if (botao) botao.disabled = false;
      });
  }

  /* ---------- ligacao com o DOM ---------- */

  function iniciar() {
    el.drawer = $('[data-cf-drawer]');
    if (!el.drawer) return;

    el.lista = $('[data-cf-lista]', el.drawer);
    el.vazio = $('[data-cf-vazio]', el.drawer);
    el.rodape = $('[data-cf-rodape]', el.drawer);
    el.notaVazia = $('[data-cf-nota-vazia]', el.drawer);
    el.fallback = $('[data-cf-fallback]', el.drawer);
    el.conta = $('[data-cf-conta]', el.drawer);
    el.fita = $('[data-cf-fita]', el.drawer);
    el.medidor = $('[data-cf-medidor]', el.drawer);
    el.medidorNum = $('[data-cf-medidor-num]', el.drawer);
    el.medidorBarra = $('[data-cf-medidor-barra]', el.drawer);
    el.medidorAviso = $('[data-cf-medidor-aviso]', el.drawer);

    /* Container dos itens, irmao do estado vazio: assim o vazio continua
       existindo no DOM e nao precisa ser reconstruido em JavaScript. */
    el.itens = document.createElement('div');
    el.itens.setAttribute('data-cf-itens', '');
    el.lista.appendChild(el.itens);

    /* ---------- gaveta vazia numa pagina que tem formulario ----------
       Pedido do Elber em 29/08.

       O botao de orcamento da barra fixa abria a gaveta sempre. Numa pagina
       de produto com o carrinho vazio isso e um beco: a gaveta diz "seu
       pedido esta vazio" bem em cima do formulario que serve para preenche-lo.
       A pessoa fecha a gaveta e volta para onde ja estava.

       Com o carrinho vazio E havendo formulario na pagina, o botao passa a
       levar ao formulario. Com item dentro, abre a gaveta como sempre.

       O teste e a PRESENCA DO FORMULARIO, e nao o nome do template: qualquer
       pagina que ganhe o formulario um dia herda o comportamento sem tocar
       aqui. Fora dele — na home, por exemplo — a gaveta continua abrindo,
       porque ali nao ha para onde mandar.

       Rolar sozinho nao basta: sem mover o foco, quem usa teclado ou leitor de
       tela continua parado no botao da barra e nao fica sabendo que a pagina
       andou. O foco vai para o TITULO do formulario, com tabindex="-1" — o
       mesmo padrao de um link de pular para o conteudo. Assim se ouve "Monte
       o seu pedido" em vez de um campo solto, e nenhum <select> abre sozinho. */

    function formularioNaPagina() {
      return document.querySelector('[data-cf-form-pedido]');
    }

    function levarAoFormulario(form) {
      var alvo = form.querySelector('.pedido-form__titulo') || form;
      if (!alvo.hasAttribute('tabindex')) alvo.setAttribute('tabindex', '-1');
      alvo.scrollIntoView({ block: 'start', behavior: 'smooth' });
      /* O foco depois da rolagem: focar antes faz o navegador saltar para o
         elemento e a rolagem suave nao acontece. */
      window.setTimeout(function () {
        if (alvo.focus) alvo.focus({ preventScroll: true });
      }, 420);
    }

    /* ---------- o papel de cada botao no modo rapido (11/09) ----------

       Primeira tentativa: os CTAs de orcamento desviavam para o catalogo.
       O Elber cortou, e a razao dele e melhor que a minha: desviar TIRA A
       PESSOA DA PAGINA. A gaveta abre por cima, sem carregar nada, e o
       estado vazio dela ja e o cardapio dos 3 produtos.

       Entao o desenho ficou com dois papeis claros:
         botao de orcamento sem produto escolhido -> abre a gaveta, que
           mostra os 3 produtos e nao leva ninguem para lugar nenhum
         botao dentro da pagina de produto -> vai direto para o WhatsApp,
           com o que a pessoa escolheu escrito na mensagem

       Quem ainda nao escolheu escolhe ali mesmo; quem ja escolheu nao
       passa por nenhuma tela a mais. */
    document.addEventListener('click', function (evento) {
      // O icone do cabecalho. Abre a gaveta sempre, vazia ou nao: e o lugar
      // onde a pessoa vai ver o que juntou, e desviar dali esconde a resposta.
      // Vem antes do data-cf-abrir de proposito, para nunca herdar o desvio.
      if (evento.target.closest('[data-cf-abrir-sempre]')) {
        evento.preventDefault();
        abrir();
        return;
      }

      // A barra fixa. Aqui o desvio faz sentido: ela e uma chamada para agir,
      // e sem nenhum item a acao util e o formulario, nao uma gaveta vazia.
      if (evento.target.closest('[data-cf-abrir]')) {
        evento.preventDefault();
        var vazio = !carrinhoAtual || !carrinhoAtual.items || !carrinhoAtual.items.length;
        var form = formularioNaPagina();
        if (vazio && form) {
          levarAoFormulario(form);
          return;
        }
        abrir();
        return;
      }
      if (evento.target.closest('[data-cf-fechar]')) {
        evento.preventDefault();
        fechar();
        return;
      }
      if (evento.target.closest('[data-cf-enviar]')) {
        evento.preventDefault();
        enviarWhatsApp();
        return;
      }

      var itemEl = evento.target.closest('.item-orc');
      if (!itemEl) return;
      var chave = itemEl.getAttribute('data-chave');
      var campo = $('[data-cf-qtd]', itemEl);
      if (!campo) return;

      if (evento.target.closest('[data-cf-remover]')) {
        evento.preventDefault();
        mudarQuantidade(chave, 0);
      } else if (evento.target.closest('[data-cf-mais]')) {
        mudarQuantidade(chave, parseInt(campo.value, 10) + 1);
      } else if (evento.target.closest('[data-cf-menos]')) {
        var novo = parseInt(campo.value, 10) - 1;
        if (novo >= 1) mudarQuantidade(chave, novo);
      }
    });

    el.drawer.addEventListener('change', function (evento) {
      var campo = evento.target.closest('[data-cf-qtd]');
      if (!campo) return;
      var itemEl = campo.closest('.item-orc');
      var valor = parseInt(campo.value, 10);
      if (isNaN(valor) || valor < 1) valor = 1;
      mudarQuantidade(itemEl.getAttribute('data-chave'), valor);
    });

    /* Digitar repinta a prévia e guarda. Um só ouvinte na gaveta: os campos
       existem desde o carregamento, mas a lista de itens é reescrita a cada
       leitura do carrinho, e ouvinte por campo se perderia junto. */
    el.drawer.addEventListener('input', function (evento) {
      if (!evento.target.closest('[data-cf-quem]')) return;
      guardarQuem();
      resumirQuem();
      if (carrinhoAtual) atualizarPrevia(carrinhoAtual);
    });

    fitaLista = lerFita();

    lembrarQuem();

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' && !el.drawer.hidden) fechar();
      prenderFoco(evento);
    });

    document.addEventListener('submit', function (evento) {
      var formulario = evento.target.closest('[data-cf-form-pedido]');
      if (!formulario) return;
      evento.preventDefault();
      adicionar(formulario);
    });

    atualizar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  window.CFPedido = { abrir: abrir, fechar: fechar, atualizar: atualizar };
})();
